import { h, Component } from 'preact';
import { joinClasses, addClass, removeClass, triggerAnim, accessNested } from 'utils/utils';
import { rawSearchLocations } from 'utils/clientUtils';
import { track } from 'utils/tracking';
import pure from 'utils/pure';
import Store from 'store/store';
import * as actions from 'store/actions';
import { SvgSearch } from 'components/shared/svgIcons/svgIcons.js';
import AutoCompleteInput from 'components/shared/autoCompleteInput/autoCompleteInput';
import s from 'components/pages/showtimes/locationSearch.sss';

export default @pure class LocationSearch extends Component {

	constructor(props) {
		super(props);
		this.updateSavedSelectionPos = this.updateSavedSelectionPos.bind(this);
		this.useExhibitorIcon = this.useExhibitorIcon.bind(this);
		this.useIcon = this.useIcon.bind(this);
		this.checkInput = this.checkInput.bind(this);
		// this.fetchSuggestionsDebounced = debounce(this.fetchSuggestions.bind(this), 200);
		let store = Store.get();
		this.postcodesOnly = accessNested(store, 'activePage.data.postcodesOnly');
		this.baseClientGeo = store.client.geo;
		this.state.cities = store.showtimes.cities || [];
		Store.on(actions.SET_CITIES, () => this.setState({ cities: Store.get().showtimes.cities || [] }));
		this.$currentFilterVal = null;
		this.previousValue = '';
		this.previousSelectionStart = 0;
		this.previousSelectionEnd = 0;
		Store.on(actions.SET_CLIENT_GEO, (geo) => {
			if (!this.baseClientGeo) { // Store the initial geoloc
				this.baseClientGeo = geo;
			}
			if (!this.$currentFilterVal && this.$input) {
				if (geo.city === this.baseClientGeo.city) {
					this.$input.setValue('');
				} else {
					this.$input.setValue(geo.city || geo.src || '?');
				}
			}
			this.queuedRawSearch = {};
			this.extraLocations = {};
		});
		this.queuedRawSearch = {};
		this.extraLocations = {};
	}

	updateSavedSelectionPos(e) {
		let input = e.target;
		this.previousSelectionStart = input.selectionStart;
		this.previousSelectionEnd = input.selectionEnd;
	}

	checkInput(e) {
		let input = e.target;
		if (this.postcodesOnly) {
			let value = input.value.replace(/ /g, '').toUpperCase();
			let usRegex = /^\d{0,5}$/;
			let caRegex = /^[a-z](\d([a-z](\d([a-z]\d?)?)?)?)?$/i;
			let newVal = value;
			let selStart = input.selectionStart;
			let selEnd = input.selectionEnd;
			if (value && !value.match(usRegex) && !value.match(caRegex)) {
				triggerAnim(this.base, s.postcodesOnly);
				newVal = this.previousValue;
				selStart = this.previousSelectionStart;
				selEnd = this.previousSelectionEnd;
			}
			newVal = newVal.replace(caRegex, v => v.slice(0, 3) + (v.length > 3 ? ' ' + v.slice(3) : ''));
			if (newVal !== this.previousValue && selStart === selEnd && selStart > 3) {
				selStart++;
				selEnd++;
			}
			input.value = newVal;
			input.selectionStart = selStart;
			input.selectionEnd = selEnd;
		}
		this.previousValue = input.value;
		this.previousSelectionStart = input.selectionStart;
		this.previousSelectionEnd = input.selectionEnd;

		this.checkSuggestions();
	}

	checkSuggestions() {
		let input = this.previousValue;
		if (input.length <= 3) {
			return;
		}

		if (this.extraLocations[input]) {
			const result = this.extraLocations[input];
			this.setState({
				searchSuggestions: this.generateSuggestionValues(result)
			});
			return;
		}

		this.fetchSuggestions(input).then(async (resultPromise) => {
			if (this.previousValue !== input) {
				return;
			}
			const result = await resultPromise;
			this.setState({
				searchSuggestions: this.generateSuggestionValues(result)
			});
		});
	}

	fetchSuggestions(input, callback = () => {}) {
		if (this.extraLocations[input]) {
			callback(this.extraLocations[input]);
			return Promise.resolve(this.extraLocations[input]);
		}
		if (!this.queuedRawSearch[input]) {
			this.queuedRawSearch[input] = rawSearchLocations(input).then(result => {
				this.extraLocations[input] = result;
				return result;
			}).catch(() => {
				delete this.queuedRawSearch[input];
				return [];
			}).then((result) => {
				callback(result);
				return result;
			});
		}

		return this.queuedRawSearch[input];
	}

	changed(selected) {
		//var selected = this.getValue();
		let value = selected.value;
		this.$currentFilterVal = null;

		// Reset current filters ?
		Store.emit(actions.RESET_FILTERS);
		if (!value) {
			// Search was cancelled (restore to first geo ; i.e. geolocated)
			if (!this.baseClientGeo) return;
			let store = Store.get();

			if (store.showtimes.error || store.client.geo !== this.baseClientGeo) {
				Store.emit(actions.SET_CLIENT_GEO, this.baseClientGeo);
			}
			return;
		}
		if (selected.type === 'match' && selected.match.type !== 'city' && selected.match.type !== 'suggestion') {
			// A filter was selected
			let m = selected.match;
			this.$currentFilterVal = m.value;
			Store.emit(actions.TOGGLE_FILTER, m.type, m.src);
			track({ a: 'filter_from_search', l: m.value, useCustomPageTrack: true });
			return;
		}

		if (selected.type === 'match') {
			// A known city was selected
			Store.emit(actions.SET_CLIENT_GEO, selected.match.src.geo);
			// Mostly for tracking purposes
			Store.emit(actions.SEARCH_NEW_CITY, selected.match.src.geo.city);
			track({ a: 'nearby_location_selected', l: 'from search hint', useCustomPageTrack: true });
			return;
		}


		// Unknown location, search for it

		// Let us know that the user is searching for a new destiniation,
		// we can't put in searchLocation as that might get called in other places
		// Store.emit(actions.SEARCH_NEW_CITY, value);

		// let store = Store.get();
		// let regionBiasing = store.appData.meta.region.slug;
		// if (accessNested(store, 'activePage.data.regionBiasingFromGeolocation')) {
		// 	regionBiasing = getGeoFromIPAsync().then(d => d.countryCode);
		// }

		// this.fetchSuggestions(value).then((result) => {
		// 	return searchLocation(result[0] || value, regionBiasing);
		// });
	}

	useIcon(dom, match) {
		dom.addEventListener('mouseenter', () => addClass(dom, s.animRunning));
		let removeAnim = () => removeClass(dom, s.animRunning);
		['webkitAnimationEnd', 'mozAnimationEnd', 'animationEnd'].forEach(ev => dom.addEventListener(ev, removeAnim));
		let icon = document.createElement('span');
		icon.className = s.icon;
		let content = document.createElement('span');
		content.className = s.content;
		content.textContent = match.label || match.value;
		dom.appendChild(icon);
		dom.appendChild(content);
	}

	useExhibitorIcon(dom, match) {
		this.useIcon(dom, match);
		let sharedImages = accessNested(this.props, 'appData.urls.roots.sharedImages', '');
		let filename = (match.src.logo || 'default.png');
		dom.firstChild.style.backgroundImage = 'url(' + sharedImages + '/logos/light/' + filename + ')';
	}

	generateSuggestionValues(extraLocations) {
		if (this.postcodesOnly) {
			return [];
		}

		let { filters } = this.props;

		let inputValues = [];
		let animated = ' ' + s.animated; // Replace with let animated = ''; to remove animations
		let showCountry = accessNested(this.props, 'appData.options.countryInSearchSuggestions');

		if (extraLocations) {
			inputValues = inputValues.concat(extraLocations.map((loc) => {
				return {
					value: this.previousValue,
					label: loc.label,
					src: { geo: loc },
					type: 'suggestion',
					order: -1,
					subOrder: 0,
					className: s.citySuggestion + animated,
					customContent: this.useIcon,
				};
			}));
		}

		inputValues = inputValues.concat(this.state.cities.filter(city => {
			let cityLower = (city.name || '').toLowerCase();
			let cityEnLower = (city.nameEn || '').toLowerCase();
			return !inputValues.some(v => {
				let vGeo = v.src && v.src.geo;
				if (!vGeo || !vGeo.city) {
					return false;
				}
				if (vGeo.countryCode !== city.geo.countryCode) {
					return false;
				}
				let existingCity = vGeo.city.toLowerCase();
				return existingCity === cityLower || existingCity === cityEnLower;
			});
		}).map((city) => {
			let value = city.name;
			let alt = null;
			if (city.geo.countryCode === 'us' && city.state) {
				value += ', ' + city.state.trim();
			}
			if (showCountry) {
				value += ', ' + city.geo.countryCode;
			}
			if (city.nameEn && city.nameEn !== city.name) {
				alt = [city.nameEn];
			}
			return {
				value: value,
				alt: alt,
				type: 'city',
				order: 0,
				subOrder: city.distance,
				className: s.citySuggestion + animated,
				customContent: this.useIcon,
				src: city
			};
		}));

		if (filters) {
			let options = accessNested(this.props, 'appData.options') || {};
			let showTitleFilter = options.useTitleFilter || options.useTitleFilterLegacy;
			Object.keys(filters).forEach((fId, i) => {
				if (fId === 'webedia' || fId === 'member' || fId === 'hour' || fId === 'minute') {
					return;
				}
				if (!showTitleFilter && fId === 'movie') {
					return;
				}
				let filter = filters[fId];
				let fClass = s[fId + 'Suggestion'];
				let customContent = fClass && this.useIcon;
				if (fId === 'exhibitor') {
					customContent = this.useExhibitorIcon;
				}
				if (fId === 'ticketProvider' && filter.options.length === 1) {
					return;
				}
				let options = filter.options.reduce((arr, opt) => {
					let display = opt[filter.displayProp];
					let existing = arr.find(o => o.display === display);
					if (existing) {
						existing.src.push(opt);
					} else {
						arr.push({ display: display, src: [opt] });
					}
					return arr;
				}, []);
				inputValues = inputValues.concat(options.map(option => {
					let val = option.display;
					let alt = null;
					if (fId === 'exhibitor') {
						val = val.split('.')[0];
						// Example of how to use with alt :
						// if (val === 'cineworld.co.uk') {
						// 	val = 'cineworld';
						// 	alt = ['cinewirld', 'cine world'];
						// } else {
						//	val = val.split('.')[0];
						// }
					}
					return {
						value: val,
						alt: alt,
						type: fId,
						order: i + 1,
						className: (fClass || s.noIconSuggestion) + animated,
						customContent: customContent,
						src: option.src
					};
				}));
			});
		}
		return inputValues;
	}

	render({ clientGeo, copy, ariaLabel }) {
		let placeholderValue = this.$currentFilterVal || (clientGeo && clientGeo.city);
		let placeholder = copy.$SEARCH;
		if (placeholderValue) {
			placeholder = [
				placeholder + ' - ',
				<span class={s.placeholderLocation}>{placeholderValue}</span>
			];
		}
		placeholder = (
			<div class={s.placeholderContent}>
				<SvgSearch class={s.placeholderSearch} />
				<div class={s.placeholderText}>{placeholder}</div>
			</div>
		);
		return (
			<div class={joinClasses(s.base, this.props.class)}>
				<AutoCompleteInput
					ref={e => this.$input = e}
					onChange={this.changed.bind(this)}
					words={this.state.searchSuggestions}
					defaultSelect
					placeholder={placeholder}
					maxPerType={20}
					doNotRedirectToEmpty
					onInput={this.checkInput}
					onKeyup={this.updateSavedSelectionPos}
					onMouseup={this.updateSavedSelectionPos}
					ariaLabel={ariaLabel}
				/>
			</div>
		);
	}

}
